module.exports = __webpack_public_path__ + "img/icon-scene1.a0eff28d.jpg";